import React from "react";
import { useSelector } from "react-redux";
import Table from "@mui/material/Table";
import { Box } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHeaderComponent from "./TableHeader";
import TableRowComponent from "./TableRow";

import { selectLocalization } from "@/store/store/selectors";

const TableComponent = (props) => {
  const { loading, marginData } = props;
  const localization = useSelector(selectLocalization);

  return (
    <Box paddingX={5} paddingTop={5}>
      <TableContainer
        sx={{
          height: 422,
        }}
      >
        <Table stickyHeader>
          <TableHeaderComponent />
          <TableRowComponent
            localization={localization}
            loading={loading}
            marginData={marginData}
          />
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TableComponent;
